import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import APIS from "../../../../../constant/Endpoint";
import { getApiData } from "../../../../../helpers/AxiosInstance";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  const blogResponse = await getApiData(APIS.BLOG, {});
  // https://stackoverflow.com/questions/73984137/how-to-define-custom-traits-on-grapes-js-and-how-to-change-the-domcomponents-as

  Components.addType("blog-detail", {
    model: {
      toHTML() {
        let innerHTML = this.components()
          .toArray()
          .map((comp: any) => comp.toHTML())
          .join(""); // Convert each child component to HTML
        let blogSlug = this.getAttributes().blogId;
        if (!blogSlug) {
          return innerHTML;
        }
        innerHTML = innerHTML.replace(
          /<!--\s*{%\s*single_blog\s+.*?\s+as\s+blog\s*%}\s*-->/,
          `{% single_blog '${blogSlug}' as blog %}`
        );
        return innerHTML;
      },
      defaults: {
        traits: [
          {
            type: "select",
            label: "Blog",
            name: "blogId",
            options: blogResponse?.data
              ? blogResponse?.data?.map((item: any) => ({
                  id: item.slug,
                  name: item.headline,
                }))
              : [],
          },
        ],
        blogSlug: "",
        components: /*html*/ `
          <div class="container mx-auto blogDetail">
                      <!-- {% single_blog blogSlug as blog %} -->

            <div class="flex flex-col gap-y-4 mx-3 md:mx-0">
              <div class="w-full">
                  <!-- {% comment %} -->
                <img
                  src="/assets/images/blogImage.png"
                  class="w-full object-contain"
                />
                  <!-- {% endcomment %} -->
              <!-- <img
                        src="{% generate_thumbnail blog.preview_image_url '1030x503/filters:format(webp)' %}"
                        alt="{{ blog.headline }}"
                        class="w-full object-contain"
                      /> -->
              </div>
              <div>
                <p class="text-2xl font-semibold">
                    <!--{% comment %} -->
                  Top Furniture Trends of 2024: What's In and What's Out
                        <!-- {% endcomment %} -->
                    <!--{{ blog.headline }} -->
                </p>
                <!-- {% comment %} -->
                <p>
                  Korem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                  eu turpis molestie, dictum est a, mattis tellus. Sed
                  dignissim, metus nec fringilla accumsan, risus sem
                  sollicitudin lacus, ut interdum tellus elit sed risus.
                  Maecenas eget condimentum velit, sit amet feugiat lectus.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos. Praesent auctor purus luctus
                  enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus
                  ex. Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur vel
                  bibendum lorem. Morbi convallis convallis diam sit amet
                  lacinia. Aliquam in elementum tellus. Curabitur tempor quis
                  eros tempus lacinia. Nam bibendum pellentesque quam a
                  convallis. Sed ut vulputate nisi. Integer in felis sed leo
                  vestibulum venenatis. Suspendisse quis arcu sem. Aenean
                  feugiat ex eu vestibulum vestibulum. Morbi a eleifend magna.
                  Nam metus lacus, porttitor eu mauris a, blandit ultrices nibh.
                  Mauris sit amet magna non ligula vestibulum eleifend. Nulla
                  varius volutpat turpis sed lacinia. Nam eget mi in purus
                  lobortis eleifend. Sed nec ante dictum sem condimentum
                  ullamcorper quis venenatis nisi. Proin vitae facilisis nisi,
                  ac posuere leo.
                </p>
                <!-- {% endcomment %} -->
              <!-- {{ blog.content|safe }} -->
              </div>
              <div>
                <div
                  class="flex items-center justify-center md:justify-start space-x-4 mt-4"
                >
                  <p class="font-semibold uppercase">Share:</p>
                  <a href="#" class="hover:text-primary">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class=""
                    >
                      <path
                        d="M28.0002 15.5415C28.0002 8.6415 22.4002 3.0415 15.5002 3.0415C8.6002 3.0415 3.0002 8.6415 3.0002 15.5415C3.0002 21.5915 7.3002 26.629 13.0002 27.7915V19.2915H10.5002V15.5415H13.0002V12.4165C13.0002 10.004 14.9627 8.0415 17.3752 8.0415H20.5002V11.7915H18.0002C17.3127 11.7915 16.7502 12.354 16.7502 13.0415V15.5415H20.5002V19.2915H16.7502V27.979C23.0627 27.354 28.0002 22.029 28.0002 15.5415Z"
                        fill="currentColor"
                      />
                    </svg>
                  </a>
                  <a href="#" class="hover:text-primary">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.7854 3.0415C18.1916 3.04525 18.9054 3.05275 19.5216 3.07025L19.7641 3.079C20.0441 3.089 20.3204 3.1015 20.6541 3.1165C21.9841 3.179 22.8916 3.389 23.6879 3.69775C24.5129 4.01525 25.2079 4.44525 25.9029 5.139C26.5387 5.76367 27.0306 6.51959 27.3441 7.354C27.6529 8.15025 27.8629 9.05775 27.9254 10.389C27.9404 10.7215 27.9529 10.9978 27.9629 11.279L27.9704 11.5215C27.9891 12.1365 27.9966 12.8503 27.9991 14.2565L28.0004 15.189V16.8265C28.0034 17.7383 27.9938 18.65 27.9716 19.5615L27.9641 19.804C27.9541 20.0853 27.9416 20.3615 27.9266 20.694C27.8641 22.0253 27.6516 22.9315 27.3441 23.729C27.0306 24.5634 26.5387 25.3193 25.9029 25.944C25.2782 26.5799 24.5223 27.0717 23.6879 27.3853C22.8916 27.694 21.9841 27.904 20.6541 27.9665L19.7641 28.004L19.5216 28.0115C18.9054 28.029 18.1916 28.0378 16.7854 28.0403L15.8529 28.0415H14.2166C13.3045 28.0447 12.3923 28.0351 11.4804 28.0128L11.2379 28.0053C10.9411 27.994 10.6445 27.9811 10.3479 27.9665C9.01788 27.904 8.11038 27.694 7.31288 27.3853C6.47891 27.0716 5.72343 26.5797 5.09913 25.944C4.46281 25.3195 3.97051 24.5635 3.65663 23.729C3.34788 22.9328 3.13788 22.0253 3.07538 20.694L3.03788 19.804L3.03163 19.5615C3.00858 18.65 2.99817 17.7383 3.00038 16.8265V14.2565C2.99692 13.3448 3.00608 12.433 3.02788 11.5215L3.03663 11.279C3.04663 10.9978 3.05913 10.7215 3.07413 10.389C3.13663 9.05775 3.34663 8.1515 3.65538 7.354C3.96999 6.51925 4.46315 5.7633 5.10038 5.139C5.72432 4.50344 6.47936 4.0116 7.31288 3.69775C8.11038 3.389 9.01663 3.179 10.3479 3.1165C10.6804 3.1015 10.9579 3.089 11.2379 3.079L11.4804 3.0715C12.3919 3.04929 13.3036 3.03971 14.2154 3.04275L16.7854 3.0415ZM15.5004 9.2915C13.8428 9.2915 12.2531 9.94998 11.081 11.1221C9.90886 12.2942 9.25038 13.8839 9.25038 15.5415C9.25038 17.1991 9.90886 18.7888 11.081 19.9609C12.2531 21.133 13.8428 21.7915 15.5004 21.7915C17.158 21.7915 18.7477 21.133 19.9198 19.9609C21.0919 18.7888 21.7504 17.1991 21.7504 15.5415C21.7504 13.8839 21.0919 12.2942 19.9198 11.1221C18.7477 9.94998 17.158 9.2915 15.5004 9.2915ZM15.5004 11.7915C15.9928 11.7914 16.4805 11.8883 16.9355 12.0767C17.3905 12.2651 17.8039 12.5413 18.1522 12.8894C18.5005 13.2376 18.7768 13.6509 18.9653 14.1059C19.1538 14.5608 19.2509 15.0484 19.251 15.5409C19.2511 16.0333 19.1542 16.521 18.9658 16.976C18.7774 17.431 18.5013 17.8444 18.1531 18.1927C17.8049 18.541 17.3916 18.8173 16.9366 19.0058C16.4817 19.1943 15.9941 19.2914 15.5016 19.2915C14.5071 19.2915 13.5532 18.8964 12.85 18.1932C12.1467 17.4899 11.7516 16.5361 11.7516 15.5415C11.7516 14.5469 12.1467 13.5931 12.85 12.8899C13.5532 12.1866 14.5071 11.7915 15.5016 11.7915M22.0641 7.4165C21.6497 7.4165 21.2523 7.58112 20.9593 7.87415C20.6662 8.16718 20.5016 8.5646 20.5016 8.979C20.5016 9.3934 20.6662 9.79083 20.9593 10.0839C21.2523 10.3769 21.6497 10.5415 22.0641 10.5415C22.4785 10.5415 22.876 10.3769 23.169 10.0839C23.462 9.79083 23.6266 9.3934 23.6266 8.979C23.6266 8.5646 23.462 8.16718 23.169 7.87415C22.876 7.58112 22.4785 7.4165 22.0641 7.4165Z"
                        fill="currentColor"
                      />
                    </svg>
                  </a>
                  <a href="#" class="hover:text-primary">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 31 31"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M28.575 8.04199C27.6125 8.47949 26.5751 8.76699 25.5 8.90449C26.6 8.24199 27.4501 7.19199 27.8501 5.92949C26.8126 6.55449 25.6625 6.99199 24.4501 7.24199C23.4625 6.16699 22.0751 5.54199 20.5001 5.54199C17.5626 5.54199 15.1625 7.94199 15.1625 10.9045C15.1625 11.3295 15.2126 11.742 15.3001 12.1295C10.85 11.9045 6.88755 9.76699 4.25005 6.52949C3.78755 7.31699 3.52505 8.24199 3.52505 9.21699C3.52505 11.0795 4.46255 12.7295 5.91255 13.667C5.02505 13.667 4.20005 13.417 3.47505 13.042V13.0795C3.47505 15.6795 5.32505 17.8545 7.77505 18.342C6.9886 18.5582 6.1626 18.5881 5.36255 18.4295C5.70206 19.4951 6.36697 20.4275 7.26382 21.0957C8.16067 21.7638 9.24436 22.1341 10.3625 22.1545C8.46714 23.6551 6.11756 24.4662 3.70005 24.4545C3.27505 24.4545 2.85005 24.4295 2.42505 24.3795C4.80005 25.9045 7.62505 26.792 10.65 26.792C20.5001 26.792 25.9126 18.617 25.9126 11.5295C25.9126 11.292 25.9125 11.067 25.9 10.8295C26.9501 10.0795 27.85 9.12949 28.575 8.04199Z"
                        fill="currentColor"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        `,
        init() {
          this.on("change:attributes:blogId", this.handleSelectBlog);
        },
        handleSelectBlog() {
          this.addAttributes({ blogSlug: this.getAttributes().blogId });
          // this.addAttributes({categoryId:this.getAttributes().category});
        },
      },
    },
  });
};
